"use client";

import React from "react";

//

export interface ConsoleErrorIgnoreProviderProps {
  children?: React.ReactNode;
}

//

export const ConsoleErrorIgnoreProvider: React.FC<ConsoleErrorIgnoreProviderProps> = ({
  children,
}) => {
  // const originalConsoleError = console.error;

  // console.error = (...args) => {
  //   if (
  //     typeof args[0] === "string" &&
  //     args[0].includes("Warning: Extra attributes from the server") &&
  //     args[1] === "control-id"
  //   ) {
  //     return;
  //   }
  //   originalConsoleError(...args);
  // };

  return children;
};
